import { render, staticRenderFns } from "./addAdvertiser.vue?vue&type=template&id=23a4c2da&"
import script from "./addAdvertiser.vue?vue&type=script&lang=js&"
export * from "./addAdvertiser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23a4c2da')) {
      api.createRecord('23a4c2da', component.options)
    } else {
      api.reload('23a4c2da', component.options)
    }
    module.hot.accept("./addAdvertiser.vue?vue&type=template&id=23a4c2da&", function () {
      api.rerender('23a4c2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/components/addAdvertiser.vue"
export default component.exports